import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "../../utils/hooks";
import CompareResponses from "./CompareResponses";

const StudyCompareResponsesWrapper = () => {
  const { id: studyId, participantId, formId } = useParams();
  const formName = useQuery().get("formName");

  return (
    <CompareResponses
      studyId={studyId}
      participantId={participantId || ""}
      formId={formId || ""}
      formName={formName || ""}
      type="study"
    />
  );
};

export default StudyCompareResponsesWrapper;
